/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import "./TakeAssessment.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle, faWarning } from "@fortawesome/free-solid-svg-icons";
import useTakeAssessment from "./useTakeAssessment";
import { Spinner, Modal } from "react-bootstrap";
import QuestionSubmitModal from "./_components/QuestionSubmitModal";
import QuestionDescription from "./_components/QuestionDescription";
import VideoProgress from "./_components/VideoProgress";
import AssessmentHeader from "../../../_components/Common/AssessmentHeader";
import { ASSESSMENT_ASSIGN_STATUS } from "../../../_constants/AssessmentConst";

export default (props) => {
  const {
    videoElement,
    saveButtonRef,
    loading,
    question,
    timer,
    videoUpload,
    uploadProgress,
    videoUploadMessage,
    confirmProgressModalOpen,
    nextEnabled,
    assessmentCompleted,
    remainingCount,
    fullScreenModalOpen,
    confirmModalOpen,
    submitAssessmentMessage,
    isErrorOccurred,
    assignAssessmentDetails,
    errorMessage,
    onCloseConfirmModal,
    onNextClick,
    onSubmitAssessmentClick,
    onConfirmSubmitAssessmentClick,
    onFullScreenClick,
    onBacktoAssessementsClick,
  } = useTakeAssessment(props);

  return (
    <>
      <AssessmentHeader />
      {assessmentCompleted ||
      (assignAssessmentDetails &&
        assignAssessmentDetails.status ===
          ASSESSMENT_ASSIGN_STATUS.completed) ||
      errorMessage === ASSESSMENT_ASSIGN_STATUS.completed ? (
        <>
          <div className="d-flex align-items-center justify-content-center h-100 mb-4">
            <div className="mt-4 border border-radius-10 p-3 bg-white">
              <div className="border-bottom text-center">
                <img
                  src="/assets/images/tick-green.svg"
                  className="mb-2"
                  alt="check"
                />
                <h3 className="mb-1">Assessment Completed</h3>
                <p className="text-grey-4 mb-3">
                  You have successfully completed this assessment kit.
                </p>
              </div>

              <div className="border-bottom py-3 mb-3">
                <div className="flex mb-2">
                  <strong className="mr-3">Title:</strong>
                  <span className="text-capitalize mb-2">
                    {assignAssessmentDetails?.assessment_id &&
                      assignAssessmentDetails?.assessment_id?.title}
                  </span>
                </div>

                <ul className="d-flex flex-wrap">
                  <li className="mr-3">
                    <strong>Skills:</strong>
                  </li>
                  {Array.isArray(
                    assignAssessmentDetails?.assessment_id &&
                      assignAssessmentDetails.assessment_id?.skills &&
                      assignAssessmentDetails.assessment_id.skills
                  ) &&
                    assignAssessmentDetails?.assessment_id &&
                    assignAssessmentDetails.assessment_id?.skills &&
                    assignAssessmentDetails.assessment_id.skills.map((item) => (
                      <li
                        className="bg-grey-2 text-left d-inline-block rounded h4 font-weight-normal px-2 py-1 text-capitalize"
                        key={item?.id}
                      >
                        {item.skill_id && item.skill_id?.skill}
                      </li>
                    ))}
                </ul>
              </div>
              <button
                className="btn w-100 btn-primary"
                onClick={() => onBacktoAssessementsClick()}
              >
                See Assigned Assessments
              </button>
            </div>
          </div>
        </>
      ) : (
        <>
          {isErrorOccurred || errorMessage ? (
            <div className="d-flex align-items-center justify-content-center h-100 mb-4">
              <div className="mt-4 border border-radius-10 p-3 bg-white">
                <div className="border-bottom text-center mb-3">
                  <img
                    src="/assets/images/REJECTED.svg"
                    className="mb-2"
                    alt="check"
                  />
                  <h3 className="mb-1">Oops!</h3>
                  <p className="text-grey-4 mb-3">
                    {errorMessage
                      ? errorMessage
                      : "Oops! Something Went Wrong...."}
                  </p>
                </div>

                <button
                  className="btn w-100 btn-primary"
                  onClick={() => onBacktoAssessementsClick()}
                >
                  See Assigned Assessments
                </button>
              </div>
            </div>
          ) : (
            <div>
              <div className="interview-wrapper bg-white mx-4 p-2 border-radius-10 border">
                {videoUpload ? (
                  <QuestionSubmitModal
                    confirmProgressModalOpen={confirmProgressModalOpen}
                    uploadProgress={uploadProgress}
                    videoUploadMessage={videoUploadMessage}
                    onNextClick={onNextClick}
                    nextEnabled={nextEnabled}
                    remainingCount={remainingCount}
                    onConfirmSubmitAssessmentClick={
                      onConfirmSubmitAssessmentClick
                    }
                  />
                ) : (
                  <div className="new-interview-screen-wrapper">
                    {loading ? (
                      <div className="d-flex justify-content-center align-items-center mt-2">
                        <Spinner
                          animation="border"
                          variant="primary"
                          className="text-white"
                        />
                      </div>
                    ) : (
                      <div className={"d-block h-100"}>
                        <>
                          {" "}
                          <div className="container text-capitalize d-flex justify-content-between align-items-center flex-wrap">
                            <h2 className="font-weight-medium py-3 flex-1 fs-20 mb-0">
                              Assessment Kit: {question?.assessment_id?.title}
                            </h2>
                            <VideoProgress
                              question={question}
                              saveButtonRef={saveButtonRef}
                              onEndInterviewClick={onSubmitAssessmentClick}
                              remainingCount={remainingCount}
                            />
                          </div>
                          <div className="container d-flex align-items-center mt-3">
                            <p className="font-weight-medium p-3 mr-3 d-inline-block border-radius-10 border mb-0">
                              {question?.assessment_id?.total_questions -
                                remainingCount +
                                1}
                              /{question?.assessment_id?.total_questions}
                            </p>
                            <QuestionDescription
                              question={question}
                              timer={timer}
                            />
                          </div>
                          <div className="position-relative mt-3">
                            <div className="video-container">
                              <video
                                id="player"
                                ref={videoElement}
                                autoPlay
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                                muted="muted"
                              ></video>
                              <span className="position-absolute text-white recording-icon bg-danger d-flex py-1 px-2 border-radius-10 align-items-center">
                                <FontAwesomeIcon
                                  icon={faCircle}
                                  className="mr-2 fs-smallest"
                                />
                                Recording
                              </span>
                            </div>
                          </div>
                        </>
                      </div>
                    )}
                  </div>
                )}
                <Modal
                  size="lg"
                  show={confirmModalOpen}
                  className="common-modal d-flex align-items-center"
                  onHide={onCloseConfirmModal}
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Warning</Modal.Title>
                  </Modal.Header>
                  <Modal.Body className="pt-3">
                    <h3 className="font-weight-normal">
                      {submitAssessmentMessage}
                    </h3>
                  </Modal.Body>

                  <Modal.Footer>
                    <button
                      className="btn btn-danger ml-3 py-2"
                      onClick={() => onConfirmSubmitAssessmentClick()}
                    >
                      Submit
                    </button>
                    <button
                      className="btn btn-primary ml-3 py-2"
                      onClick={onCloseConfirmModal}
                    >
                      Cancel
                    </button>
                  </Modal.Footer>
                </Modal>

                {assessmentCompleted ||
                (assignAssessmentDetails &&
                  assignAssessmentDetails.status ===
                    ASSESSMENT_ASSIGN_STATUS.completed) ? null : (
                  <Modal
                    size="lg"
                    show={fullScreenModalOpen}
                    className="common-modal d-flex align-items-center"
                  >
                    <Modal.Body className="p-3">
                      <p className="my-2">
                        <FontAwesomeIcon
                          icon={faWarning}
                          className="mr-2 text-danger"
                        />
                        To many reloads can lead to interview termiation.
                      </p>
                      <p className="my-2">
                        <FontAwesomeIcon
                          icon={faWarning}
                          className="mr-2 text-danger"
                        />
                        Please go fullScreen mode to continue interview.
                      </p>
                      <div className="text-center pt-2">
                        <button
                          className="btn btn-primary mt-3"
                          onClick={onFullScreenClick}
                        >
                          Full Screen Mode
                        </button>
                      </div>
                    </Modal.Body>
                  </Modal>
                )}
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};
